import React, { useState } from "react";
import { Modal, ModalBody } from "reactstrap";

function CustomModal(props) {
  const {
    buttonLabel,
    leftTitle,
    leftDescription,
    rightTitle,
    rightDescription,
  } = props;

  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);
  return (
    <div className="custom-modal-wrapper">
      <a className="modal-trigger" onClick={toggle}>
        {buttonLabel}
      </a>
      <Modal
        isOpen={modal}
        toggle={toggle}
        centered={true}
        className="custom-modal"
      >
        <ModalBody>
          <button
            type="button"
            class="close"
            aria-label="Close"
            onClick={toggle}
          ></button>
          <div className="modal-body-left">
            <div className="modal-body-left-title">{leftTitle}</div>
            <div className="modal-body-left-content">{leftDescription}</div>
          </div>
          <div className="modal-body-right">
            <div className="modal-body-right-title">{rightTitle}</div>
            <div className="modal-body-right-content">{rightDescription}</div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default CustomModal;
